// extracted by mini-css-extract-plugin
export default {"tipseenWizard":"components-Tipseen-TipseenWizard-module__tipseenWizard--aHy1T","tipseenWizardWizard":"components-Tipseen-TipseenWizard-module__tipseenWizardWizard--LYP4n"};